module.exports = __webpack_public_path__ + "static/img/pattern_1.7da8dd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/pattern_1.jpg
// module id = VZgE
// module chunks = 1